import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CARNET_ACCENTS } from "@/data/constants";
import { ArrowRight, Lock, Sparkles } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const cardImg = (n) => `${BACKEND}/api/game/ile/image/${n}`;

export default function Aventures() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/adventure/books").then((r) => setBooks(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <section className="relative overflow-hidden bg-[#1F2A24] text-[#F6F2E9]">
        <div className="absolute inset-0 opacity-25" style={{ backgroundImage: `url(${cardImg(1)})`, backgroundSize: "cover", backgroundPosition: "center", filter: "blur(3px)" }} />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom, rgba(31,42,36,0.78), rgba(31,42,36,0.92))" }} />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-8 py-20 md:py-28 text-center">
          <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#C9A24B] font-semibold">
            Les Livres-Carnets d'Aventure
          </p>
          <h1 className="font-serif text-4xl md:text-6xl mt-4 leading-tight">L'Île de l'Abondance</h1>
          <div className="gold-divider w-24 mx-auto my-6" />
          <p className="font-serif italic text-lg md:text-xl text-[#F6F2E9]/90 max-w-2xl mx-auto">
            « Une histoire. Des centaines de chemins. Et un seul héros : vous. »
          </p>
          <p className="font-sans text-sm text-[#F6F2E9]/70 mt-5 max-w-xl mx-auto leading-relaxed">
            Devenez le héros d'une aventure en 21 étapes. À chaque étape, vos choix dessinent la suite
            de l'histoire. Les 3 premières étapes sont gratuites.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 py-14 md:py-20">
        {loading ? (
          <p data-testid="aventures-loading" className="text-center font-sans text-[#1F2A24]/60">Chargement…</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="aventures-grid">
            {books.map((b, i) => (
              <AventureCard key={b.id} book={b} accent={CARNET_ACCENTS[i % CARNET_ACCENTS.length]} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

const AventureCard = ({ book, accent }) => (
  <div
    data-testid={`adventure-book-${book.slug}`}
    className="rounded-2xl bg-white border border-[#E8DCC4] overflow-hidden flex flex-col"
  >
    <div className="aspect-[16/10] relative overflow-hidden" style={{ background: `linear-gradient(150deg, ${accent}, ${accent}bb)` }}>
      {book.available && (
        <img src={cardImg(2)} alt={book.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-90" />
      )}
      <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(31,42,36,0.8), rgba(31,42,36,0.15))" }} />
      <div className="relative h-full flex flex-col justify-between p-5">
        <span className="inline-flex items-center gap-1.5 self-start rounded-full bg-black/25 px-3 py-1 font-sans text-[11px] tracking-wider text-white">
          {book.available ? <Sparkles size={12} /> : <Lock size={12} />}
          {book.available ? "DISPONIBLE" : "À VENIR"}
        </span>
        <span className="font-serif text-2xl text-white leading-tight drop-shadow-md">{book.title}</span>
      </div>
    </div>
    <div className="p-5 flex flex-col flex-1">
      <p className="font-serif italic text-sm text-[#1F2A24]/75 flex-1 leading-relaxed">{book.tagline}</p>
      <div className="mt-5">
        {book.available ? (
          <Link
            to={`/aventure/${book.id}`}
            data-testid={`adventure-open-${book.slug}`}
            className="inline-flex w-full justify-center items-center gap-2 rounded-full bg-[#385E3A] text-white px-5 py-3 font-ui text-sm hover:bg-[#2c4a2e] transition-colors"
          >
            COMMENCER L'AVENTURE <ArrowRight size={16} />
          </Link>
        ) : (
          <span className="inline-block w-full text-center rounded-full bg-[#E8DCC4] text-[#1F2A24]/60 px-5 py-3 font-ui text-sm">
            BIENTÔT DISPONIBLE
          </span>
        )}
      </div>
    </div>
  </div>
);
